<template>
    <multiselect
        v-bind="$attrs"
        :value="selectedTags"
        :options="tagOptions"
        label="name"
        track-by="id"
        multiple
        v-on="$listeners"
    >
        <template #tag="{ option, remove }">
            <span class="multiselect__tag" :title="option.$isDisabled ? 'Permission required to change this tag' : ''">
                <span>{{ option.name }}</span>
                <i v-if="!option.$isDisabled" class="multiselect__tag-icon" @click="remove(option)" />
            </span>
        </template>
    </multiselect>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        value: { type: Array, default: () => [] },
        options: { type: Array, default: () => [] },
    },
    computed: {
        tagOptions() {
            return this.options.map(tag => ({ ...tag, $isDisabled: tag.can_modify !== true }))
        },
        selectedTags() {
            return (this.value || []).map(tag => {
                const option = this.tagOptions.find(option => String(option.id) === String(tag.id))
                // Selected tags may come from a media/article response without permission metadata.
                // Keep them locked until the tag catalog has loaded.
                return { ...tag, $isDisabled: !option || option.$isDisabled }
            })
        },
    },
}
</script>
